import { useEffect, useReducer } from 'react';

import {
  MAXIMIZES_REVENUE_DEMAND_ANIMATION_FRAMES,
  MAXIMIZES_REVENUE_DEMAND_FRAME_MS,
  MAXIMIZES_REVENUE_DEMAND_REDUCED_MOTION_FRAME,
} from './MaximizesRevenuePanel.constants';

const frameToState = frame => ({
  frameIndex: frame.frameIndex,
  figmaVariant: frame.figmaVariant,
  classTimeKey: frame.classTimeKey,
  demandSubtitleKey: frame.demandSubtitleKey,
  leftVisible: frame.leftVisible ?? [],
  rightVisible: frame.rightVisible ?? [],
  leftGreen: frame.leftGreen ?? [],
  rightGreen: frame.rightGreen ?? [],
  leftCircleVariant: frame.leftCircleVariant ?? 'blue',
  rightCircleVariant: frame.rightCircleVariant ?? 'blue',
  checkmarkSide: frame.checkmarkSide ?? null,
  lowerEarningsKey: frame.lowerEarningsKey ?? 'first',
  higherEarningsKey: frame.higherEarningsKey ?? 'first',
  showEarnings: Boolean(frame.showEarnings),
});

const initialAnimatedState = frameToState({
  ...MAXIMIZES_REVENUE_DEMAND_ANIMATION_FRAMES[0],
  frameIndex: 0,
});

const actionTypes = {
  APPLY_FRAME: 'APPLY_FRAME',
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.APPLY_FRAME:
      return { ...state, ...action.frameState };
    default:
      return state;
  }
};

export const useMaximizesRevenueDemandAnimation = ({ prefersReducedMotion = false } = {}) => {
  const [state, dispatch] = useReducer(
    reducer,
    prefersReducedMotion ? frameToState(MAXIMIZES_REVENUE_DEMAND_REDUCED_MOTION_FRAME) : initialAnimatedState
  );

  useEffect(() => {
    if (prefersReducedMotion) {
      return undefined;
    }

    let frameIndex = 0;
    let timeoutId = null;
    let cancelled = false;

    const scheduleNextFrame = () => {
      const frame = MAXIMIZES_REVENUE_DEMAND_ANIMATION_FRAMES[frameIndex];

      timeoutId = setTimeout(() => {
        if (cancelled) {
          return;
        }

        frameIndex = (frameIndex + 1) % MAXIMIZES_REVENUE_DEMAND_ANIMATION_FRAMES.length;
        const nextFrame = MAXIMIZES_REVENUE_DEMAND_ANIMATION_FRAMES[frameIndex];

        dispatch({
          type: actionTypes.APPLY_FRAME,
          frameState: frameToState({ ...nextFrame, frameIndex }),
        });

        scheduleNextFrame();
      }, frame.holdMs ?? MAXIMIZES_REVENUE_DEMAND_FRAME_MS);
    };

    scheduleNextFrame();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [prefersReducedMotion]);

  return state;
};
